export default "__VITE_ASSET__CwziEF7u__"